import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=183f6070&scoped=true"
import script from "./tables.vue?vue&type=script&lang=js"
export * from "./tables.vue?vue&type=script&lang=js"
import style0 from "./tables.vue?vue&type=style&index=0&id=183f6070&prod&scoped=true&lang=css"
import style1 from "./tables.vue?vue&type=style&index=1&id=183f6070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f6070",
  null
  
)

export default component.exports